module.exports = __webpack_public_path__ + "static/media/white_plane.c5a7c1a0.svg";